
    import { mapState, mapActions, mapMutations } from 'vuex';
    import C1Tag from '@/C1Components/C1Tag.vue';
    import C1TagAdd from '@/C1Components/C1TagAdd.vue';

    export default {
        name: 'JobViewTags',
        components: {
            C1Tag,
            C1TagAdd,
        },
        props: {
            label: {
                type: String,
                default: '',
            },

            attributeId: {
                type: Number,
                required: true,
            },

            options: {
                type: Array,
                default: () => [],
            },

            seekerOptions: {
                type: Array,
                default: () => [],
            },

            variant: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                selectedAttributeOption: {},
                mutableOptions: [],
                showPromptModal: false,
                loginPrompt: {
                    component_name: 'LoginPrompt',
                    title: 'Login or sign up',
                    code: 'SIMPLE_LOGIN',
                    site_position: 'login_signup_popup',
                    page_referral_element: 'job_view_tags',
                    options: {
                        login_redirect: '_none',
                    },
                },
            };
        },

        computed: {
            ...mapState({
                $_me: state => state.me.user,
            }),

            classList() {
                return [
                    'job-tags',
                    this.getVariantClass,
                ];
            },

            matchedOptions() {
                return this.mutableOptions.filter(o => o.is_selected);
            },

            notMatchedOptions() {
                return this.mutableOptions.filter(o => !o.is_selected);
            },

            getVariantClass() {
                return this.variant ? `is-${this.variant}` : '';
            },

            seekerOptionsIds() {
                return this.seekerOptions.map(o => o.id) || [];
            },
        },

        watch: {
            seekerOptions() {
                this.cloneOptions();
            },
        },

        created() {
            this.cloneOptions();
        },

        methods: {
            ...mapActions('me', {
                $_attachAttribute: 'attachAttribute',
                $_detachAttribute: 'detachAttribute',
            }),

            ...mapActions('eventTracking', {
                $_pushEvent: 'pushEvent',
            }),

            ...mapMutations('me', {
                $_STORE_ATTRIBUTE_OPTION: 'STORE_ATTRIBUTE_OPTION',
                $_PUT_ATTRIBUTE_OPTION: 'PUT_ATTRIBUTE_OPTION',
                $_DESTROY_ATTRIBUTE_OPTION: 'DESTROY_ATTRIBUTE_OPTION',
            }),

            cloneOptions() {
                if (this.options.length) {
                    this.mutableOptions = this.options.map((o) => {
                        return {
                            ...o,
                            is_selected: this.seekerOptionsIds.includes(o.id),
                        };
                    });
                    const matchedOptions = this.mutableOptions.filter(o => o.is_selected);
                    matchedOptions.sort((a, b) => a.value.localeCompare(b.value));
                    const nonMatchedOptions = this.mutableOptions.filter(o => !o.is_selected);
                    nonMatchedOptions.sort((a, b) => a.value.localeCompare(b.value));
                    this.mutableOptions = [...matchedOptions, ...nonMatchedOptions];
                }
            },

            onAttributeSelected(attributeOption, isSelected) {
                if (!this.$_me.id) {
                    this.selectedAttributeOption = attributeOption;
                    this.openPromptModal();
                } else if (isSelected) {
                    this.attachAttribute(attributeOption);
                } else {
                    this.detachAttribute(attributeOption);
                }
            },

            attachAttribute(attributeOption) {
                attributeOption.is_selected = true;
                const data = {
                    attribute_option_id: attributeOption.id,
                };

                this.$_attachAttribute({ id: this.attributeId, data }).then((response) => {
                    this.$_PUT_ATTRIBUTE_OPTION(response.data);
                });
            },

            detachAttribute(attributeOption) {
                attributeOption.is_selected = false;
                const data = {
                    attribute_option_ids: [attributeOption.id],
                };

                this.$_detachAttribute({ id: this.attributeId, data }).then(() => {
                    this.$_DESTROY_ATTRIBUTE_OPTION(attributeOption.id);
                });
            },

            onPromptSuccess() {
                this.attachAttribute(this.selectedAttributeOption);
                this.closePromptModal();
            },

            openPromptModal() {
                this.showPromptModal = true;
            },

            closePromptModal() {
                this.showPromptModal = false;
            },
        },
    };
